/* ==========================================================================
   お問い合わせページ（templates/page.contact.liquid 専用 / 掲載希望事業者むけLP）

   1. 「内容を確認」→ 入力チェック → 確認モーダル → 送信
   2. 4つの理由カード：SP のみ横スクロールカルーセル（矢印／ドット連動）
   3. select 未選択時のプレースホルダ色

   バニラJS。jQuery / Swiper には依存しない。
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('otm-lp');
  if (!root) return;

  /* ------------------------------------------------------------------------
     1. 確認モーダル
     ------------------------------------------------------------------------ */
  (function initConfirm() {
    var form = root.querySelector('#otm-contact-form');
    var modal = root.querySelector('#otm-modal');
    if (!form || !modal) return; // 送信完了後はフォームが無い

    var mBody = root.querySelector('#otm-modal-body');
    var btnOpen = root.querySelector('#otm-confirm-btn');
    var btnEdit = root.querySelector('#otm-modal-edit');
    var btnSend = root.querySelector('#otm-modal-send');
    var hidName = root.querySelector('#otm-name-hidden');

    /* 行ごとに値を集めて確認用の dl を組み立てる */
    function collect() {
      var out = [];
      Array.prototype.forEach.call(form.querySelectorAll('.otm-row'), function (row) {
        var vals = [];
        Array.prototype.forEach.call(row.querySelectorAll('input, select, textarea'), function (f) {
          if (f.type === 'hidden') return;
          var v = (f.value || '').trim();
          if (v) vals.push(v);
        });
        out.push({
          label: row.getAttribute('data-otm-label') || '',
          value: vals.join('　')
        });
      });
      return out;
    }

    function openModal() {
      mBody.innerHTML = '';
      collect().forEach(function (item) {
        var dt = document.createElement('dt');
        dt.textContent = item.label;
        var dd = document.createElement('dd');
        dd.textContent = item.value || '（未入力）';
        mBody.appendChild(dt);
        mBody.appendChild(dd);
      });
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    btnOpen.addEventListener('click', function () {
      /* form に novalidate を付けているのでここで明示的にチェックする
         （novalidate は送信時の検証だけを止め、checkValidity は動く） */
      if (!form.checkValidity()) {
        form.reportValidity();
        var ng = form.querySelector(':invalid');
        if (ng) ng.focus();
        return;
      }
      var sei = (root.querySelector('#otm-sei').value || '').trim();
      var mei = (root.querySelector('#otm-mei').value || '').trim();
      hidName.value = (sei + ' ' + mei).trim();
      openModal();
    });

    btnEdit.addEventListener('click', closeModal);
    btnSend.addEventListener('click', function () {
      btnSend.disabled = true;
      btnSend.textContent = '送信中…';
      form.submit();
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    /* select は未選択のときだけプレースホルダ色 */
    var select = root.querySelector('#otm-category');
    if (select) {
      var sync = function () { select.classList.toggle('is-filled', select.value !== ''); };
      select.addEventListener('change', sync);
      sync();
    }
  })();

  /* ------------------------------------------------------------------------
     2. 4つの理由カルーセル（SPのみ。PCはグリッドなのでスクロールしない）
     ------------------------------------------------------------------------ */
  (function initCarousel() {
    var track = root.querySelector('#otm-cards');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.otm-card'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.otm-carousel-dots button'));
    var prev = root.querySelector('.otm-carousel-nav--prev');
    var next = root.querySelector('.otm-carousel-nav--next');
    if (!cards.length) return;

    function current() {
      /* 横スクロール量から現在のカードを求める（PCでは常に0） */
      var w = cards[0].offsetWidth;
      if (!w) return 0;
      return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / w)));
    }

    function goTo(i) {
      var idx = Math.max(0, Math.min(cards.length - 1, i));
      /* scrollTo(options) は古い iOS Safari が無視して 0 に飛ぶので使わない。
         なめらかさは CSS の scroll-behavior:smooth に任せる */
      track.scrollLeft = cards[0].offsetWidth * idx;
    }

    function syncDots() {
      var idx = current();
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        syncDots();
        ticking = false;
      });
    });
    syncDots();
  })();
})();
